import { useSearchParams } from "react-router-dom";
import MembershipCMSComponent from "../MembershipCMSComponent";
import MembershipDetailsComponent from "../MembershipDetailsComponent";
import StepperComponent from "../StepperComponent";
import MembershipAddCouponComponent from "../MembershipAddCouponComponent";

const MembershipCreationComponent = () => {
  const [params, _setParams] = useSearchParams();
  const page_step = params.get("page_step");
  return (
    <>
      <div className="p-3 pt-0 bg-white w-full">
        <div className="p-3 shadow-md  py-3 rounded-lg sticky top-16 bg-white z-30">
          <p className="text-base font-semibold">Membership Setup</p>
          <StepperComponent />
        </div>
        <div>
          {page_step === "general_details" && <MembershipDetailsComponent />}
          {page_step === "add_coupon" && <MembershipAddCouponComponent />}
          {page_step === "membership_cms" && <MembershipCMSComponent />}
        </div>
      </div>
    </>
  );
};

export default MembershipCreationComponent;
